export default {
	cbtList: [],
	cbtListPageInfo: {},
	selectedCBT: {},
	roomCBT: {},
	roomCBTUserList: [],
	showAnswer: true,
	roomCBTDoc: {},
	cbtLogList: [],
	cbtLogListPageInfo: {},
	cbtLog: {},
	cbtLogUser: {}
}
